import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { tabIcons } from "@shared/models/tab-icons";

export interface ITab<TState = unknown> {
    tabId: number;
    tabTitle: string;
    tabTitleIconDefinition?: IconDefinition;
    tabText?: string | null;
    tabComponentUrl: string;
    tabState: TState | null;
    isActive: boolean;
    isPinned?: boolean;
    queryParams?: Record<string, unknown>;
}

export const defaultTab = Object.freeze({
    tabId: 0,
    tabComponentUrl: "bedside-shift-report",
    tabTitleIconDefinition: tabIcons.BedsideShiftReport,
    isActive: true,
    isPinned: false,
} as ITab);
